import { BetaSignup } from './components/BetaSignup';
import { CTA } from './components/CTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { LegalWorkflows } from './components/LegalWorkflows';
import { SafeIdeaSolution } from './components/SafeIdeaSolution';
import { Security } from './components/Security';
import { TheProblem } from './components/TheProblem';
import { WhyAIDifferent } from './components/WhyAIDifferent';

export default function Welcome() {
  return (
    <div className="min-h-screen bg-background">
      <Hero />
      <TheProblem />
      <WhyAIDifferent />
      <SafeIdeaSolution />
      <HowItWorks />
      <Security />
      <LegalWorkflows />
      <BetaSignup />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
